import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tool.file.metadata.logo.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tool.file.metadata.logo.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/tool/file/tool.file.metadata.logo.vue?vue&type=script&lang=js&
// module id = 784
// module chunks = 3